import React from 'react';
import heartIcon from './heartIcon.json';

interface HeartIconProps {
  className?: string;
  style?: React.CSSProperties;
}

// Inline SVG heart, 1em square like the FontAwesome glyph it replaces. Unlike
// <i className="fas fa-heart">, it draws on first render instead of waiting
// for the icon font, so it matches the prerendered fallback's heart at mount.
const HeartIcon: React.FC<HeartIconProps> = ({ className, style }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    viewBox={heartIcon.viewBox}
    width="1em"
    height="1em"
    className={className}
    style={{ verticalAlign: '-0.125em', ...style }}
  >
    <path fill="currentColor" d={heartIcon.path} />
  </svg>
);

export default HeartIcon;
